import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GrouponService {
  
  baseUrl = environment.baseUrl;


  constructor(private http:HttpClient,
    private datePipe: DatePipe,) { }
  
  get_groupon_orders() {
    return this.http.get(this.baseUrl + '/groupon/get_orders');  
  }

  get_order_by_id(id) {
    return this.http.get(this.baseUrl + '/groupon/get_order_by_id/' + id);  
  }

  update_groupon_status(order_id, FormData) {
    return this.http.post(this.baseUrl + '/groupon/update_groupon_status/' + order_id,{
      new_status_id: FormData.order_status_id
    });  
  }

  groupon_get_questionnaire(order_item_id) {
    return this.http.get(this.baseUrl + '/groupon/groupon_get_questionnaire/' + order_item_id);  
  }



}
